import { bundlePlanForm } from "../components/types";

/** A bundle plan row as returned by the listing endpoint. */
export interface BundlePlanRow {
  id: string;
  mno_id?: string;
  ussd_plan_code?: number;
  bundle_id?: string;
  amount_incl_tax?: number;
  amount_excl_tax?: number;
  internal_subscription_fee?: number;
  plan_types?: string[];
  plan_name?: string;
  created_at?: string;
  updated_at?: string;
}

/** The selectable plan types. A plan can be any combination of these. */
export const PLAN_TYPE_OPTIONS = ["Voice", "Data", "SMS"];

/** Maximum plan amount permitted for both the inclusive and exclusive amounts. */
export const MAX_PLAN_AMOUNT = 9999;

/** Rows per page, matching the page size MainTable and the API both use. */
export const PAGE_SIZE = 10;

/** Character limits enforced on the free text fields. */
export const BUNDLE_ID_MAX_LENGTH = 15;
export const PLAN_NAME_MAX_LENGTH = 250;

export const bundlePlanInitialState: bundlePlanForm = {
  ussd_plan_code: "",
  bundle_id: "",
  amount_excl_tax: "",
  amount_incl_tax: "",
  internal_subscription_fee: "",
  plan_name: "",
};

/**
 * Builds the input configuration for the bundle plan form.
 *
 * When creating, the USSD plan code is omitted: it is allocated by the backend on
 * save. When editing it is shown first but always disabled, because the code is
 * already in circulation and the edit endpoint rejects it.
 */
export const getBundlePlanInputs = (edit?: boolean) => ({
  "": {
    ...(edit && {
      "USSD Plan Code": {
        required: true,
        disabled: true,
        id: "ussd_plan_code",
        type: "input",
        tabIndex: 0,
      },
    }),
    "Bundle ID": {
      required: true,
      disabled: false,
      id: "bundle_id",
      type: "input",
      maxLength: BUNDLE_ID_MAX_LENGTH,
      tabIndex: 0,
      placeholder: "Ex: 12344",
    },
    "Amount excl. Tax": {
      required: true,
      disabled: false,
      id: "amount_excl_tax",
      type: "currency",
      tabIndex: 0,
      min: 0,
      max: MAX_PLAN_AMOUNT,
      // The currency field renders its error absolutely, so the row needs room for a
      // wrapped message rather than letting it overlap the fields below.
      extraSpaceBelow: true,
    },
  },
});
